import { render, staticRenderFns } from "./SidebarRight.vue?vue&type=template&id=06b24e64&scoped=true"
import script from "./SidebarRight.vue?vue&type=script&lang=js"
export * from "./SidebarRight.vue?vue&type=script&lang=js"
import style0 from "./SidebarRight.vue?vue&type=style&index=0&id=06b24e64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b24e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b24e64')) {
      api.createRecord('06b24e64', component.options)
    } else {
      api.reload('06b24e64', component.options)
    }
    module.hot.accept("./SidebarRight.vue?vue&type=template&id=06b24e64&scoped=true", function () {
      api.rerender('06b24e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layout/SidebarRight.vue"
export default component.exports